<template>
    <dl class="quickscan-history">
        <div
            v-for="(row, index) in quickscanTimeline"
            :key="index"
        >
            <dt>
                <BaseIcon icon="check-circle" />
                {{ row.question }}
            </dt>
            <dd> {{ row.answer }}</dd>
        </div>
    </dl>
</template>

<script setup>
import { quickscanTimeline } from './timeline';
</script>

<style lang="less" src="./History.less" />
